module.exports = __webpack_public_path__ + "static/yum_hero_bg-003ce76646b8e1f0317519f178b330bb.jpg";